import { Suspense } from 'react'
import RouterConfig from 'router/RouterConfig'

function App() {
  return (
    <Suspense fallback={''}>
      <RouterConfig />
    </Suspense>
  )
}

export default App
